const SITE_HEADER_SELECTOR = '[data-site-header]';

const createHeaderController = (element) => {
  const button = element.querySelector('[data-site-header-menu-button]');
  const panel = element.querySelector('[data-site-header-menu-panel]');
  const backdrop = element.querySelector('[data-site-header-menu-backdrop]');
  const menuLinks = Array.from(element.querySelectorAll('[data-site-header-menu-link]'));
  if (!button || !panel || !backdrop) return null;

  const openClass = 'aspri-site-header--menu-open';
  const setMenuState = (isOpen) => {
    button.classList.toggle('aspri-site-header__menu-button--active', isOpen);
    button.setAttribute('aria-expanded', String(isOpen));
    element.classList.toggle(openClass, isOpen);
  };

  const onKeyDown = (event) => {
    if (event.key === 'Escape') {
      setMenuState(false);
      removeListeners();
    }
  };

  const onPointerDown = (event) => {
    if (panel.contains(event.target) || button.contains(event.target)) return;
    setMenuState(false);
    removeListeners();
  };

  const openMenu = () => {
    setMenuState(true);
    document.addEventListener('keydown', onKeyDown);
    document.addEventListener('pointerdown', onPointerDown);
  };

  const closeMenu = () => {
    setMenuState(false);
    removeListeners();
  };

  const removeListeners = () => {
    document.removeEventListener('keydown', onKeyDown);
    document.removeEventListener('pointerdown', onPointerDown);
  };

  button.addEventListener('click', () => {
    const isOpen = element.classList.contains(openClass);
    if (isOpen) {
      closeMenu();
    } else {
      openMenu();
    }
  });

  backdrop.addEventListener('click', closeMenu);
  menuLinks.forEach((link) => {
    link.addEventListener('click', closeMenu);
  });
};

const initializeHeaders = () => {
  const headers = Array.from(document.querySelectorAll(SITE_HEADER_SELECTOR));
  return headers.map((element) => createHeaderController(element)).filter(Boolean);
};

document.addEventListener('DOMContentLoaded', () => {
  initializeHeaders();
});
